import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ElementRef, Renderer2, OnDestroy } from '@angular/core';

// export type ResizeEventData = {
//   width: any;
// }

@Component({
    selector: 'app-resizable',
    templateUrl: './resizable.component.html',
    styleUrls: ['./resizable.component.scss'],
    standalone: false
})
export class ResizableComponent implements OnChanges, OnDestroy, OnInit {
  dragging!: boolean;
  resizableGrabWidth = 8;
  resizableMinWidth = 10;
  @Input() containerWidth!: number;
  resizableWidth = '45vw';
  viewportWidth = window.innerWidth;
  private documentClickListener: () => void;
  // OnOpen OnClosed OnResized
  // @Output() OnOpen: EventEmitter<any> = new EventEmitter();
  // @Output() OnResized: EventEmitter<any> = new EventEmitter();
  @Output() OnClosed: EventEmitter<any> = new EventEmitter();

  @Input() closeOnOutsideClick = true;
  @Input() noBgScroll = true;


  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
    const newWidth = (wid: any) => {
      this.resizableWidth = wid + 'px';
    };

    const mouseMoveG = (evt: any) => {
      if (!this.dragging) {
        return;
      }
      if (this.viewportWidth - evt.clientX < 400) {
        return;
      }

      newWidth(this.viewportWidth - evt.clientX);
      evt.stopPropagation();
    };
    const mouseUpG = (evt: any) => {
      if (!this.dragging) {
        return;
      }
      this.dragging = false;
      evt.stopPropagation();
    };
    document.addEventListener('mousemove', mouseMoveG, true);
    document.addEventListener('mouseup', mouseUpG, true);

    // Add a document click listener
    // this.documentClickListener = this.renderer.listen('document', 'click', (event: Event) => {
    //   this.onDocumentClick(event);
    // });

    // Add a document mousedown listener
    this.documentClickListener = this.renderer.listen('document', 'mousedown', (event: Event) => {
      this.onDocumentClick(event);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['containerWidth']?.currentValue) {
      this.resizableWidth = changes['containerWidth'].currentValue + 'vw';
    }
  }

  ngOnInit(): void {
    // console.log('resizable', 'Component initialized');
    if (this.noBgScroll) {
      // Add the no-scroll class to the body element when the component is initialized to prevent scrolling when the dialog is open
      document.body.classList.add('no-scroll');
    }
    document.body.classList.add('hide-scroll');
  }

  mouseDown(evt: any) {
    if (this.inDragRegion(evt)) {
      this.dragging = true;
      evt.stopPropagation();
    }
  }

  inDragRegion(evt: any) {
    return true;
  }

  ngOnDestroy(): void {
    // console.log('resizable', 'Component destroyed');
    // Remove the document click listener when the component is destroyed to avoid memory leaks
    if (this.documentClickListener) {
      this.documentClickListener();
    }

    if (this.noBgScroll) {
      // Remove the no-scroll class from the body element when the component is destroyed to allow scrolling when the dialog is closed
      document.body.classList.remove('no-scroll');
    }
    document.body.classList.remove('hide-scroll');
  }

  private onDocumentClick(event: Event): void {
    // Prevent handling if currently dragging
    if (this.dragging) {
      return;
    }

    const clickedInside = this.elRef.nativeElement.contains(event.target);

    // Add logic to exclude certain elements like modals, dialogs, etc.
    const clickedElement = event.target as HTMLElement;

    const isExcludedElement = clickedElement.closest('.modal, .dialog, .overlay-panel, [role="dialog"], [role="alertdialog"], .p-component-overlay, .p-dialog-mask, .overlay-container, .toast-container, .resize-safe, [resize-safe], [resizesafe], .timer-container, #gtx-trans');

    if (!clickedInside && !isExcludedElement) {
      // Add a small delay to prevent immediate reopening
      setTimeout(() => {
        this.handleOutsideClick();
      }, 10);
    }
  }


  handleOutsideClick(): void {
    // Double-check dragging state and close conditions
    if (!this.dragging && this.closeOnOutsideClick) {
      this.closeResizer();
    }
  }

  onOverlayClick(event: MouseEvent): void {
    if (!this.dragging && this.closeOnOutsideClick) {
      this.closeResizer();
    }
  }

  closeResizer() {
    this.resizableWidth = '0px';
    this.OnClosed.emit();
  }
  openResizer() {
    this.resizableWidth = '45vw';
    // this.OnOpen.emit();
  }


}
